export const reservationAgreementFr = `
<html>
<head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type">
    <style type="text/css">ol {
        margin: 0;
        padding: 0
    }

    table td, table th {
        padding: 0
    }

    .c0 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 11pt;
        font-family: "Arial";
        font-style: normal
    }

    .c5 {
        color: #000000;
        font-weight: 700;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 13pt;
        font-family: "Arial";
        font-style: normal
    }

    .c1 {
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left;
        height: 11pt
    }

    .c9 {
        color: #000000;
        font-weight: 700;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 11pt;
        font-family: "Arial";
        font-style: normal
    }

    .c3 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 11pt;
        font-family: "Arial";
        font-style: normal
    }

    .c7 {
        color: #1155cc;
        text-decoration: underline;
        vertical-align: baseline;
        font-size: 11pt;
        font-style: normal
    }

    .c2 {
        padding-top: 12pt;
        padding-bottom: 12pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    .c4 {
        padding-top: 14pt;
        padding-bottom: 4pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    .c10 {
        background-color: #ffffff;
        max-width: 468pt;
        padding: 72pt 72pt 72pt 72pt
    }

    .c10z {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 20pt;
        font-family: "Arial";
        font-style: normal;
    }

    .c8 {
        font-size: 13pt;
        font-weight: 700
    }

    .c11 {
    }

    .c6 {
        height: 11pt
    }

    .title {
        padding-top: 0pt;
        color: #000000;
        font-size: 26pt;
        padding-bottom: 3pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    .subtitle {
        padding-top: 0pt;
        color: #666666;
        font-size: 15pt;
        padding-bottom: 16pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    li {
        color: #000000;
        font-size: 11pt;
        font-family: "Arial"
    }

    p {
        margin: 0;
        color: #000000;
        font-size: 11pt;
        font-family: "Arial"
    }

    h1 {
        padding-top: 20pt;
        color: #000000;
        font-size: 20pt;
        padding-bottom: 6pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
    }

    h2 {
        padding-top: 18pt;
        color: #000000;
        font-size: 16pt;
        padding-bottom: 6pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h3 {
        padding-top: 16pt;
        color: #434343;
        font-size: 14pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h4 {
        padding-top: 14pt;
        color: #666666;
        font-size: 12pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h5 {
        padding-top: 12pt;
        color: #666666;
        font-size: 11pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left
    }

    h6 {
        padding-top: 12pt;
        color: #666666;
        font-size: 11pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        font-style: italic;
        orphans: 2;
        widows: 2;
        text-align: left
    }</style>
</head>
<body class="c10 doc-content">

<h1><span class="c10z">Entente de r&eacute;servation</span></h1>

<p class="c0"><span class="c2"></span></p>
<p class="c3"><span class="c2">Dernière mise à jour: 2025-04-16</span></p>

<p class="c1"><span class="c3"></span></p>
<p class="c2"><span class="c3">La pr&eacute;sente entente de r&eacute;servation (&laquo; Entente &raquo;) r&eacute;git le d&eacute;p&ocirc;t d&rsquo;une r&eacute;servation (&laquo; R&eacute;servation &raquo;) aupr&egrave;s de PakVille™ Construction Corp., situ&eacute;e au 618, av. Meloche, Dorval (Qu&eacute;bec), Canada (&laquo; PakVille™ &raquo;), pour l&rsquo;achat &eacute;ventuel d&rsquo;une maison PakVille™ (&laquo; Maison PakVille™ &raquo;). Veuillez lire attentivement cette Entente avant de soumettre votre R&eacute;servation. En soumettant votre R&eacute;servation, vous acceptez d&rsquo;&ecirc;tre l&eacute;galement li&eacute; par tous les termes de la pr&eacute;sente Entente.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.v8du15wmlfql"><span class="c5">1. Objet de l&rsquo;entente</span></h3>
<p class="c2"><span class="c3">En versant les frais de r&eacute;servation, vous r&eacute;servez une opportunit&eacute; d&rsquo;acheter une Maison PakVille™ dans le futur. Cette Entente ne vous oblige pas &agrave; acheter une Maison PakVille™, et PakVille™ n&rsquo;est pas tenue de vous en vendre une. Il ne s&rsquo;agit pas d&rsquo;un contrat de vente, de location ou de construction pour une unit&eacute; pr&eacute;cise, et cela ne garantit ni une date de livraison, ni un prix, ni des sp&eacute;cifications finales.</span>
</p>
<p class="c2"><span class="c3">Lorsque les maisons seront pr&ecirc;tes &agrave; &ecirc;tre configur&eacute;es, PakVille™ vous contactera pour finaliser votre configuration. Vous recevrez alors une estimation du prix et des options disponibles. Pour proc&eacute;der &agrave; l&rsquo;achat, vous devrez signer une Entente de Vente Finale distincte, qui inclura tous les termes contractuels, incluant le prix final, les taxes et frais applicables.</span>
</p>
<p class="c2"><span>En effectuant une R&eacute;servation, vous confirmez avoir au moins 18 ans ou l&rsquo;&acirc;ge l&eacute;gal dans votre province/territoire et avoir la capacit&eacute; juridique de conclure cette Entente. Si vous r&eacute;servez au nom d&rsquo;une entreprise ou d&rsquo;un organisme, vous confirmez avoir l&rsquo;autorit&eacute; n&eacute;cessaire pour engager cette entit&eacute;. PakVille™ se r&eacute;serve le droit d&rsquo;accepter ou de refuser toute R&eacute;servation &agrave; sa seule discr&eacute;tion.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.l70ce7fg876y"><span class="c5">2. Frais de r&eacute;servation</span></h3>
<p class="c2"><span class="c3">Des frais uniques de 150 $ CA vous seront factur&eacute;s lors de votre R&eacute;servation. Ces frais ne constituent pas un acompte sur l&rsquo;achat d&rsquo;une Maison PakVille™ et ne garantissent pas l&rsquo;attribution ni la livraison d&rsquo;une unit&eacute;.</span>
</p>
<p class="c2"><span class="c3">Vous pouvez annuler votre R&eacute;servation en tout temps et obtenir un remboursement complet en &eacute;crivant &agrave; <a class="c7" href="mailto:info@pakville.ca">info@pakville.ca</a> &agrave; partir de l&rsquo;adresse courriel utilis&eacute;e lors de la R&eacute;servation.</span>
</p>
<p class="c2"><span class="c3">Si vous proc&eacute;dez &agrave; l&rsquo;achat d&rsquo;une Maison PakVille™, les frais de r&eacute;servation seront d&eacute;duits du montant final &agrave; payer.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.q04vvls2yvdy"><span class="c5">3. Estimation pr&eacute;liminaire du prix</span></h3>
<p class="c2"><span class="c3">Toute estimation fournie avant la signature de l&rsquo;Entente de Vente Finale est indicative seulement, sans engagement de la part de PakVille™.</span>
</p>
<p class="c2"><span>L&rsquo;estimation peut exclure les taxes, frais de livraison, permis, raccordements aux services publics ou autres frais. Le prix final d&eacute;pendra de la configuration choisie et de l&rsquo;&eacute;volution des co&ucirc;ts avant la signature de l&rsquo;Entente de Vente Finale.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.jx86ojp1pe2w"><span class="c5">4. Livraison</span></h3>
<p class="c2"><span class="c3">La priorit&eacute; de livraison est influenc&eacute;e par la date de paiement des frais de r&eacute;servation. La livraison r&eacute;elle d&eacute;pend de la disponibilit&eacute;, du calendrier de construction, de la configuration finale et de la signature de l&rsquo;Entente de Vente Finale.</span>
</p>
<p class="c2"><span>PakVille™ ne garantit aucune date de livraison et n&rsquo;est pas responsable des retards caus&eacute;s par les permis, la construction, les cha&icirc;nes d&rsquo;approvisionnement, la m&eacute;t&eacute;o ou autres facteurs impr&eacute;vus.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.7o93c16t7rns"><span
        class="c5">5. Politique de confidentialit&eacute; et conditions de service</span></h3>
<p class="c2"><span class="c11">Toute information personnelle sera trait&eacute;e conform&eacute;ment &agrave; notre <a class="c7" href="/fr/politique-de-confidentialite">politique de confidentialit&eacute;</a> et &agrave; nos <a class="c7" href="/fr/conditions-de-service">conditions de service</a>. Veuillez consulter ces documents pour comprendre comment vos donn&eacute;es seront utilis&eacute;es et prot&eacute;g&eacute;es.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.h1weohwgindl"><span class="c5">6. Limitation de responsabilit&eacute;</span></h3>
<p class="c2"><span>Dans toute la mesure permise par la loi, PakVille™ ne pourra &ecirc;tre tenue responsable de tout dommage indirect, sp&eacute;cial ou cons&eacute;cutif li&eacute; &agrave; cette Entente ou &agrave; votre R&eacute;servation. Votre seul recours est le remboursement des frais de r&eacute;servation.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.p0pxjeo0h2ff"><span class="c5">7. Non-cession et revente interdite</span></h3>
<p class="c2"><span class="c3">Votre R&eacute;servation ne peut &ecirc;tre transf&eacute;r&eacute;e ou revendue sans le consentement &eacute;crit de PakVille™. Toute R&eacute;servation suspect&eacute;e d&rsquo;&ecirc;tre faite de mauvaise foi ou &agrave; des fins de revente pourra &ecirc;tre annul&eacute;e.</span>
</p>
<p class="c2 c6"><span class="c3"></span></p>
<p class="c2"><span>PakVille™ se r&eacute;serve le droit de v&eacute;rifier votre identit&eacute; ou de demander des documents justificatifs &agrave; tout moment.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.9jyutwxtu7x"><span class="c5">8. Lois applicables</span></h3>
<p class="c2"><span>La pr&eacute;sente Entente est r&eacute;gie par les lois de la province de Qu&eacute;bec et les lois f&eacute;d&eacute;rales du Canada applicables dans cette province.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.7sis55tw2ovw"><span class="c5">9. R&egrave;glement des litiges</span></h3>
<p class="c2"><span>Pour toute question ou litige, veuillez nous &eacute;crire &agrave; <a class="c7" href="mailto:info@pakville.ca">info@pakville.ca</a>. Nous nous engageons &agrave; collaborer avec vous de bonne foi pour r&eacute;soudre tout diff&eacute;rend efficacement.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.p9soz8toel6y"><span class="c5">10. Renonciation aux recours collectifs et aux proc&egrave;s devant jury</span>
</h3>
<p class="c2"><span>Dans la mesure permise par la loi et &agrave; l&rsquo;exception des r&eacute;sidents du Qu&eacute;bec, vous acceptez de ne pas intenter de recours collectif ni de demander un proc&egrave;s devant jury. Les litiges seront tranch&eacute;s individuellement par un tribunal comp&eacute;tent.</span>
</p>
<hr>
<p class="c1"><span class="c3"></span></p>
<h3 class="c4" id="h.xwej0atckwwd"><span class="c5">11. Entr&eacute;e en vigueur</span></h3>
<p class="c2"><span>Cette Entente entre en vigueur d&egrave;s la r&eacute;ception de vos frais de R&eacute;servation par PakVille™ et votre acceptation &eacute;lectronique sur notre site web.</span>
</p>
</body>
</html>`;
